const blockOtherProducts = (Swiper, Navigation, Pagination, Autoplay) => {
	let otherProductsSwiper = document.querySelector('.s-other-products__swiper');
	if (otherProductsSwiper) {
		otherProductsSwiper = new Swiper('.s-other-products__swiper', {
			slidesPerView: 1,
			spacebetween: 30,
			modules: [Navigation, Pagination, Autoplay],
			navigation: {
				nextEl: '.c-swiper-single-arrow--other-products.c-swiper-single-arrow--next',
				prevEl: '.c-swiper-single-arrow--other-products.c-swiper-single-arrow--prev',
			},
			breakpoints: {
				768: {
					slidesPerView: 2,
				},
				1200: {
					slidesPerView: 3,
				},
				1400: {
					slidesPerView: 4,
				},
			},
		});
	}
};

export default blockOtherProducts;
